var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useState } from 'react';
import { Heading, Text, Button, Box } from '@chakra-ui/react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
var BirthdayPicture = function (props) {
    var _a = useState(new Date()), startDate = _a[0], setStartDate = _a[1];
    function getYear(fullYear) {
        var temp = fullYear.toString();
        return temp.slice(-2);
    }
    function getDay(date) {
        var temp = date.toString();
        if (date < 10) {
            return '0' + temp;
        }
        return temp;
    }
    return (_jsx(_Fragment, { children: _jsxs(Box, __assign({ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: 'column', h: "75vh" }, { children: [_jsx(Heading, __assign({ noOfLines: 2, className: "title", textTransform: 'uppercase', width: "50%", fontSize: '3rem', my: "4" }, { children: "What picture did NASA take on your birthday?" })), _jsxs(Box, __assign({ display: 'flex', alignItems: "center", my: 5 }, { children: [_jsx(Text, { children: "Birth Date: " }), _jsx(Box, __assign({ bg: '#19113C', p: "2", mx: 2 }, { children: _jsx(DatePicker, { selected: startDate, onChange: function (date) { return setStartDate(date); } }) })), _jsx(Button, __assign({ onClick: function () {
                                var year = getYear(startDate.getFullYear());
                                var month = getDay(startDate.getMonth());
                                var date = getDay(startDate.getDate());
                                window.open("https://apod.nasa.gov/apod/ap".concat(year).concat(month).concat(date, ".html"), '_blank');
                            } }, { children: "Go" }))] }))] })) }));
};
export default BirthdayPicture;
